import React, { useEffect, useState } from 'react'
import { OBJECT_NET, OBJECT_OBJECT } from '../../../../store/Settings/sets'
import { cl } from '../../../../utilities/cl'
import { prepareSettings } from '../../utilities/prepareSettings'
import { carryUpdate } from '../../utilities/carryUpdate'
import { updateHelper } from '../../utilities/updateHelper'
import { setsex, setsmob } from '../../utilities/setsclasses'
import fields from './fields'
import Builder from '../../Builder'
import ItemSave from './items/save'
import fieldExtravolume from "./items/extravolume";
import fieldDymmyad from "./items/dummyad";

import { useDispatch } from 'react-redux'


const SettingsObjectAdvert = ({
    className = "",
    settings = {},
    stateKey,
    loadSettings,
    updateOptions,
    saveSettings,
}) => {



    const dispatch = useDispatch()
    className = cl(className, "SettingsObjectAdvert")


    let validMap
    [settings, validMap] = prepareSettings({
        type: OBJECT_OBJECT,
        settings: settings,
    })


    updateOptions = carryUpdate({
        type: OBJECT_OBJECT,
        stateKey,
        updateOptions
    })

    const hChange = (name, data) => updateHelper({
        name,
        updateOptions: data || updateOptions
    })

    const settingsLog = fields.map(field => ({ [field]: settings[field] }))

    console.log("ObjectAdvert", settingsLog, settings);


    return (
        <Builder
            className={className}
            groups={{
                all: [{
                    data: {
                        columns: 1,
                        className: setsex(["col-1"]) + setsmob(["col-1"]) + " mb-5",
                    },
                    items: [
                        {
                            title: "Громкость экстренных роликов",
                            // disabled: multiple,
                            components: fieldExtravolume({
                                settings,
                                name: "extravolume",
                                onChange: hChange("extravolume"),
                                placeholder: "Введите громкость",
                                fieldClassName: "w-100",
                            }),
                        },
                        {
                            title:
                                "Количество треков перед рекламой без расписания (только для аудио)",
                            components: fieldDymmyad({
                                settings,
                                name: "dummyad",
                                onChange: hChange("dummyad"),
                            }),
                        },
                    ],
                },
                // Save
                {
                    data: {
                        className: setsex(["col-2-nowrap"]),
                    },
                    items: [
                        <ItemSave
                            settings={settings}
                            stateKey={stateKey}
                            fields={fields}
                            saveSettings={saveSettings}
                            disabled={!validMap.validResult}
                        />,
                    ],
                }],
            }}
        />
    )
}

export default SettingsObjectAdvert